module.exports = __webpack_public_path__ + "static/img/poverty.969147e0.svg";